import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const OurTeam = () => {
    return (
        <>
            <Navbar></Navbar>
            <div className="container py-5 my-5">
                <h1>Our Team coming soon...</h1>
            </div>
        </>
    );
};

export default OurTeam;